import { Presentation } from "../lib/types";
const bgImg = require("./img/react-umbraco-triangles.png");
const umbracoLogo = require("./img/umbraco.png");
const reactLogo = require("./img/react-logo.svg");
const windowNotDefined = require("./img/window-not-defined.png");

const presentation: Presentation = {
	title: "umbreacto",
	style: {
		backgroundImage: `url(${bgImg})`,
	},
	theme: {
		primaryColor: "#61dafb",
		secondaryColor: "rgb(244,128,99)",
		rootFontSize: "3vh",
		transition: "fade",
	},
	slides: [
		{
			content: `

<div>

# Umb-React-O
## Hows that for a mash up?

</div>

<div style="display: flex; height: 70%;">

![](${umbracoLogo})

![](${reactLogo})

</div>
`,
			justify: "-",
		},
		{
			content: `
# What is Umbraco?

#### Umbraco is a CMS (Content Management System) written in dot net framework.

#### All content/data in Umbraco is accessible from razor pages.

<img src="${umbracoLogo}" width="340"/>
`,
		},
		{
			content: `
# What is react?

#### React is a javascript frontend framework used to render content and provide a highly _reactive responsive_ user experience by doing all processing client-side.
<img src="${reactLogo}" width="500" />
`,
		},
		{
			content: `
# TLDR

## Umbraco: C# backend

## React: Javascript frontend
            `,
		},
		{
			content: `
# So how do we get Umbraco to talk to React?

### This is difficult because all of our data is in C# and we want to render it in javascript

`,
		},
		{
			content: `
# What about server side rendering?
`,
		},
		{
			content: `
## This would be a great solution _but_ we're using 3rd party components that aren't set up for SSR...

<img src="${windowNotDefined}" height="400"/>

`,
		},
		{
			content: `
# How about getting our data from an API?

`,
		},
		{
			content: `
# So how did we do it?
            `,
		},
		{
			content: `
## C# - render the macro

~~~
@{
    // 1. Grab data from Umbraco
    var name = Model.Content.Name; // "Method4"

    // 2. Convert data into a json object, as a string
    var props = $"{ "name": {name} }";
}

@{// 3. Render our special react-component Umbraco macro }

@Umbraco.RenderMacro("ReactComponent",
    {
        componentName="HelloWorld",
        props=props
    }
)

~~~
            `,
		},
		{
			content: `
## C# - inside the macro

~~~
@inherits Umbraco.Web.Macros.PartialViewMacroPage

@{
    var componentName = Model.MacroParameters["componentName"];
    var props = Model.MacroParameters["props"];
}

<div class="react-component--@componentName">
    <textarea class="react-component--props">
        @props
    </textarea>
</div>

~~~
`,
		},
		{
			content: `
# We get the following markup

~~~

<div class="react-component--HelloWorld">
    <textarea class="react-component--props">
        {
            name: "Method4"
        }
    </textarea>
</div>

~~~
            `,
		},
		{
			content: `
## Javascript - grabbing the data

~~~
import React from "react";
import ReactDOM from "react-dom";
import { HelloWorld } from "../reactComponents/HelloWorld";

document.querySelectorAll('.react-component--HelloWorld')
        .forEach(element => {
            let props = JSON.parse(element.querySelector("textarea.react-component--props").value);
            ReactDOM.render(<HelloWorld {...props} />, element);
        }
);

~~~
`,
		},
		{
			content: `
## React - render our component
~~~
export const HelloWorld = (props) => {
    return <h1>Hello {props.name}</h1>
}
~~~
`,
		},
		{
			content: `
## LIVE DEMO

#### _This is where it all goes wrong_
            `,
		},
	],
};

export default presentation;
